'use strict';

export function getStripePriceStatus(price) {
  const amount = Number(price.price);
  if (Number.isNaN(amount) || amount === 0) {
    return {
      status: 'free',
      label: 'Free — no Stripe',
      hint: 'Free plans activate instantly in the app. Stripe is not used.',
      icon: 'fa-gift'
    };
  }

  if (price.stripePriceId && price.stripeProductId) {
    return {
      status: 'synced',
      label: 'Synced with Stripe',
      hint: 'This price is linked to Stripe Checkout. Customers can purchase it.',
      icon: 'fa-circle-check'
    };
  }

  return {
    status: 'pending',
    label: 'Not synced yet',
    hint: 'Click "Save price" to create this price in Stripe automatically.',
    icon: 'fa-clock'
  };
}

export function summarizeTierStripe(prices = [], tierStripeProductId = null) {
  const active = prices.filter((p) => p.isActive !== false);
  const paid = active.filter((p) => Number(p.price) > 0);
  const synced = paid.filter((p) => p.stripePriceId && p.stripeProductId);
  const pending = paid.filter((p) => !p.stripePriceId || !p.stripeProductId);
  const free = active.filter((p) => Number(p.price) === 0);

  return {
    activeCount: active.length,
    paidCount: paid.length,
    syncedCount: synced.length,
    pendingCount: pending.length,
    freeCount: free.length,
    tierProductSynced: Boolean(tierStripeProductId),
    allPaidSynced: paid.length > 0 && pending.length === 0,
    readyForCheckout: paid.length === 0 || pending.length === 0
  };
}

export function stripeDashboardProductUrl(productId) {
  if (!productId) return null;
  return `https://dashboard.stripe.com/products/${productId}`;
}

export async function copyToClipboard(text) {
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
